import * as React from "react";
import { useParams } from "react-router-dom";

import KeyDeviceForm from "../../../components/Forms/KeyDevice/FlowForm/FlowForm";

export default () => {
    const { id } = useParams();
  return <KeyDeviceForm method="PATCH" id={id}/>;
};
